<template>
  <v-container class="container-layout">
    <template
      v-if="manifests && manifests.length > 0"
    >
      <!-- <div class="manifest"> -->

        {{ resetCounterEvent() }}
        <div class="data_loop"
          v-for="(manifest, index) in manifests"
          :key="manifest.id"
        >

          {{ beforeCountUpEvent(manifest.manifest_transports.length) }}
          <hr v-if="breakFlag" class="print-break" style="margin-top: 5px;margin-bottom: 5px;" />

          <!-- <div class="manifest"> -->

          <!-- サンプルブロック -->
          <v-row v-if="breakCounter === 0" style="margin-left: 2px;margin-right: 2px;margin-top: 0px;margin-bottom: 0px;">
            <v-col
              style="padding-left:0px;padding-right:0px;padding-bottom:6px"
            >
              <div class="table">
                <div class="table_line">
                  <div class="block table_line_index" style="width: 12mm; vertical-align: middle;">
                    <label>No</label>
                  </div>
                  <div class="block" style="width: 278mm;">
                    <!-- 1行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;マニフェスト番号</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;連絡番号１</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;排出事業者　（加入者番号　名称）</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 92mm;">
                        <span>&nbsp;処分業者　（加入者番号　許可番号　名称）</span>
                      </div>
                    </div>
                    <!-- /1行目 -->

                    <!-- 2行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;登録の状態</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;連絡番号２</span>
                      </div>
                      <div class="block bordered" style="width: 94mm;">
                      </div>
                      <div class="block bordered" style="width: 92mm;">
                      </div>
                    </div>
                    <!-- /2行目 -->

                    <!-- 3行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;引渡し日</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;連絡番号３</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;排出事業場　（名称）</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 92mm;">
                        <span>&nbsp;処分事業場　（名称）</span>
                      </div>
                    </div>
                    <!-- /3行目 -->

                    <!-- 4行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 90mm;">
                        <span>&nbsp;廃棄物の種類（分類コード）</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;排出事業場所在地</span>
                      </div>
                      <div class="block bordered" style="width: 92mm;">
                        <span>&nbsp;処分事業場所在地</span>
                      </div>
                    </div>
                    <!-- /4行目 -->

                    <!-- 5行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 90mm;">
                        <span>&nbsp;大分類名称</span>
                      </div>
                      <div class="block bordered" style="width: 94mm;">
                      </div>
                      <div class="block bordered" style="width: 42mm;">
                        <span>&nbsp;受入量</span>
                      </div>
                      <div class="block bordered" style="width: 50mm;">
                        <span>&nbsp;処分終了日（報告区分）</span>
                      </div>
                    </div>
                    <!-- /5行目 -->

                    <!-- 6行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;数量</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;荷姿</span>
                      </div>
                      <div class="block bordered" style="width: 47mm;">
                        <span>&nbsp;確定数量</span>
                      </div>
                      <div class="block bordered" style="width: 47mm;">
                        <span>&nbsp;数量の確定者</span>
                      </div>
                      <div class="block bordered" style="width: 42mm;">
                        <span>&nbsp;処分方法</span>
                      </div>
                      <div class="block bordered" style="width: 50mm;">
                        <span>&nbsp;最終処分終了日</span>
                      </div>
                    </div>
                    <!-- /6行目 -->

                    <div class="table_line">
                      <div class="block table_line_section" style="width: 10mm; vertical-align: middle;">
                        <label>区間</label>
                      </div>
                      <div class="block" style="width: 268mm;">
                        <!-- 7行目 -->
                        <div class="table_line">
                          <div class="block bordered_section_top" style="width: 80mm;">
                            <span>&nbsp;収集運搬業者（加入者番号　許可番号　名称）</span>
                          </div>
                          <div class="block bordered_section_top" style="width: 94mm;">
                            <span>&nbsp;運搬先事業場の名称</span>
                          </div>
                          <div class="block bordered_section_top" style="width: 42mm;">
                            <span>&nbsp;運搬量</span>
                          </div>
                          <div class="block bordered_section_top" style="width: 50mm;">
                            <span>&nbsp;車両番号（収集運搬）</span>
                          </div>
                        </div>
                        <!-- /7行目 -->

                        <!-- 8行目 -->
                        <div class="table_line">
                          <div class="block bordered_bottomless" style="width: 35mm;">
                          </div>
                          <div class="block bordered_bottomless" style="width: 45mm;border-top: solid 1px #999;">
                            <span>&nbsp;車両番号（排出）</span>
                          </div>
                          <div class="block bordered_bottomless" style="width: 94mm;">
                            <span>&nbsp;運搬先事業場の所在地</span>
                          </div>
                          <div class="block bordered_bottomless" style="width: 42mm;border-top: solid 1px #999;">
                            <span>&nbsp;有価物拾集量</span>
                          </div>
                          <div class="block bordered_bottomless" style="width: 22mm;border-top: solid 1px #999;">
                            <span>&nbsp;運搬方法</span>
                          </div>
                          <div class="block bordered_bottomless" style="width: 28mm;border-top: solid 1px #999;">
                            <span>&nbsp;運搬終了日</span>
                          </div>
                        </div>
                        <!-- /8行目 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /サンプルブロック -->

          <!-- データブロック１ -->
          {{ headCountUpEvent() }}
          <v-row style="margin-left: 2px;margin-right: 2px;margin-bottom: 1px;margin-top: 0px;">
            <v-col
              style="padding-left:0px;padding-right:0px;padding-top:0px;padding-bottom:0px"
            >
              <div class="table">
                <div class="table_line">
                  <div class="block table_line_index" style="width: 12mm; vertical-align: middle;">
                    <label>{{ index + 1 }}</label>
                  </div>
                  <div class="block" style="width: 278mm;">
                    <!-- 1行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.manifest_no }}</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.contact_number_1 }}</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;{{ manifest.supplier_subscriber_number }} {{ manifest.supplier_name }}</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 92mm;">
                        <span>&nbsp;{{ manifest.disposal_subscriber_number }} {{ manifest.disposal_permit_number }} {{ manifest.disposal_name }}</span>
                      </div>
                    </div>
                    <!-- /1行目 -->

                    <!-- 2行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.registration_status_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.contact_number_2 }}</span>
                      </div>
                      <div class="block bordered" style="width: 94mm;">
                      </div>
                      <div class="block bordered" style="width: 92mm;">
                      </div>
                    </div>
                    <!-- /2行目 -->

                    <!-- 3行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.collected_date | date_format }}</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.contact_number_3 }}</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;{{ manifest.supplier_location_name }}</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 92mm;">
                        <span>&nbsp;{{ manifest.disposal_location_name }}</span>
                      </div>
                    </div>
                    <!-- /3行目 -->

                    <!-- 4行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 90mm;">
                        <span>&nbsp;{{ manifest.item_code }} {{ manifest.item_name }}</span>
                      </div>
                      <div class="block bordered_bottomless" style="width: 94mm;">
                        <span>&nbsp;{{ manifest.supplier_location_address }}</span>
                      </div>
                      <div class="block bordered" style="width: 92mm;">
                        <span>&nbsp;{{ manifest.disposal_location_address }}</span>
                      </div>
                    </div>
                    <!-- /4行目 -->

                    <!-- 5行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 90mm;">
                        <span>&nbsp;{{ manifest.parent_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 94mm;">
                      </div>
                      <div class="block bordered" style="width: 42mm;">
                        <span>&nbsp;{{ manifest.disposal_report_amount | number_format }} {{ manifest.disposal_report_amount_unit_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 50mm;">
                        <span>&nbsp;{{ manifest.disposal_report_end_date | date_format }}</span><span v-if="manifest.disposal_report_type">({{ manifest.disposal_report_type }})</span>
                      </div>
                    </div>
                    <!-- /5行目 -->

                    <!-- 6行目 -->
                    <div class="table_line">
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.quantity | number_format }} {{ manifest.quantity_unit_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 45mm;">
                        <span>&nbsp;{{ manifest.packing_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 47mm;">
                        <span>&nbsp;{{ manifest.fixed_quantity | number_format }} {{ manifest.fixed_quantity_unit_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 47mm;">
                        <span>&nbsp;{{ manifest.quantity_confirm_name }}</span>
                      </div>
                      <div class="block bordered" style="width: 42mm;">
                        <span>&nbsp;{{ manifest.disposal_method_name }}</span>
                      </div>
                      <div v-if="manifest.disposal_end_last_date != null" class="block bordered" style="width: 50mm;">
                        <span>&nbsp;{{ manifest.disposal_end_last_date | date_format }}</span>
                      </div>
                      <div v-else class="block bordered" style="width: 50mm;">
                        <span>&nbsp;{{ manifest.disposal_report_end_date | date_format }}</span>
                      </div>
                    </div>
                    <!-- /6行目 -->

                    <div
                      v-for="(manifest_transport) in manifest.manifest_transports"
                      :key="manifest_transport.id"
                    >
                      <div
                        v-if="mode === 'all' || (mode === 'current' && manifest_transport.current_tenant_transport_section)"
                        class="table_line"
                      >
                        {{ sectionCountUpEvent() }}
                        <div class="block table_line_section" style="width: 10mm; vertical-align: middle;">
                          <label>&nbsp;{{ manifest_transport.section }}</label>
                        </div>
                        <div class="block" style="width: 268mm;">
                          <!-- 7行目 -->
                          <div class="table_line">
                            <div class="block bordered_section_top" style="width: 80mm;">
                              <span>&nbsp;{{ manifest_transport.transport.subscriber_number }} {{ manifest_transport.transport.permit_number }} {{ manifest_transport.transport.name }}</span>
                            </div>
                            <div class="block bordered_section_top" style="width: 94mm;">
                              <span>&nbsp;{{ manifest_transport.trader_location.name }}</span>
                            </div>
                            <div class="block bordered_section_top" style="width: 42mm;">
                              <span>&nbsp;{{ manifest_transport.transport_end_report.report_transport_quantity }}</span>
                            </div>
                            <div class="block bordered_section_top" style="width: 50mm;">
                              <span>&nbsp;{{ manifest_transport.transport_end_report.report_vehicle_number }}</span>
                            </div>
                          </div>
                          <!-- /7行目 -->

                          <!-- 8行目 -->
                          <div class="table_line">
                            <div class="block bordered_bottomless" style="width: 35mm;">
                            </div>
                            <div class="block bordered_bottomless" style="width: 45mm;border-top: solid 1px #999;">
                              <span v-if="manifest_transport.section === 1">&nbsp;{{ manifest.vehicle_number }}</span>
                            </div>
                            <div class="block bordered_bottomless" style="width: 94mm;">
                              <span>&nbsp;{{ manifest_transport.trader_location.address }}</span>
                            </div>
                            <div class="block bordered_bottomless" style="width: 42mm;border-top: solid 1px #999;">
                              <span>&nbsp;{{ manifest_transport.transport_end_report.report_valuables_collecting_quantity | number_format }} {{ manifest_transport.transport_end_report.report_valuables_collecting_quantity_unit_name }}</span>
                            </div>
                            <div class="block bordered_bottomless" style="width: 22mm;border-top: solid 1px #999;">
                              <span>&nbsp;{{ manifest.transportation_name }}</span>
                            </div>
                            <div class="block bordered_bottomless" style="width: 28mm;border-top: solid 1px #999;">
                              <span>&nbsp;{{ manifest_transport.transport.transport_end_report_at | date_format }}</span>
                            </div>
                          </div>
                          <!-- /8行目 -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /データブロック１ -->
          <!-- </div> -->
        </div>
      <!-- </div> -->
    </template>
    <template
      v-else-if="manifests && manifests.length <= 0"
    >
      <h2 class="text-center">
        出力可能な受注がありません。
      </h2>
    </template>
  </v-container>

</template>

<script>
export default {
  name: "ConfirmationListTemplate",
  components: {},
  mixins: [],
  props: {
    manifests: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      systemTime: null,
      mode: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    const params = this.$route.query
    this.mode = params.mode
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
  },
  methods: {
    /**
     * 改ページ前チェック
     */
    beforeCountUpEvent(section_count) {
      // 規定値を超える場合、改ページのリセットを行う
      if (this.breakCounter + 3 > 12 || (this.infoCounter > 1 && this.breakCounter + 2 + section_count > 12)) {
        this.breakFlag = true
        this.breakCounter = 0
        this.infoCounter = 0
      }
    },
    /**
     * マニフェスト部の重み加算
     */
    headCountUpEvent() {
      this.breakFlag = false
      this.breakCounter = this.breakCounter + 2
      this.infoCounter = this.infoCounter + 1
    },
    /**
     * 区間部の重み加算
     */
    sectionCountUpEvent() {
      this.breakFlag = false
      this.breakCounter = this.breakCounter + 1
    },
    /**
     * カウンターリセット
     */
    resetCounterEvent() {
      this.breakCounter = 0
      this.infoCounter = 0
      this.breakFlag = false
    },
  }
}
</script>

<style scoped lang="scss">
body {
  overflow-y: scroll;
  font-size: 10px;
  font-family: serif;
  counter-reset: sheet;
}
.sheet::after {
  position: absolute;
  top: 0;
  right: 0;
  counter-increment: sheet;
  content: "ページ " counter(sheet);
}
.container-layout {
  border: solid 1px #ddd;
  width: 100%;
  background-color: #fff;
  font-family: serif;
}

.data_loop {
  width: 290mm;
  margin-top: 1px;
  margin-bottom: 1px;
}

.table {
  border: 2px solid #999;
}

.table_line {
  display: table;
  width: 100%;
  height: 3.5mm;
  line-height: 0.95;
}

.table_line_index {
  border-right: solid 2px #999;
  display: table;
  height: 3.5mm;
  line-height: 0.95;
  text-align: center;
}

.table_line_section {
  border-right: solid 1px #999;
  border-top: solid 1px #999;
  display: table;
  height: 3.5mm;
  line-height: 0.95;
  text-align: center;
}

.block {
  display: table-cell;
  color: #000;
  &.label {
    background-color: #dddddd;
    text-align: center;
    font-size: 25%;
  }
  &.bordered {
    border-right: solid 1px #999;
    border-bottom: solid 1px #999;
  }
  &.bordered_section_top {
    border-right: solid 1px #999;
    border-top: solid 1px #999;
  }
  &.bordered_bottomless {
    border-right: solid 1px #999;
  }
  & label {
    font-size: 80%;
  }
  & span {
    font-size: 65%;
    vertical-align: middle;
  }
  & p {
    font-size: 60%;
    margin-bottom: 0;
  }

}

hr {
  page-break-after: always;
}

// @page {
//   size: A4 landscape; /* A4横 */
//   // margin: 0;
// }

@media print {
  .container-layout {
    border: none;
    margin: 0px;
  }
  .print-break {
    page-break-after: always;
    border: none;
  }
}
</style>
